import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-celo-side-menu-sub-list",
  templateUrl: "./celo-side-menu-sub-list.component.html",
  styleUrls: ["./celo-side-menu-sub-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CeloSideMenuSubListComponent {
  @Input() celoTemplate;
}
